// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_placeholder__f1ZSI {
  width: 54vw;
  height: 18vh; }
  .styles_placeholder__f1ZSI > div:last-child {
    display: flex;
    justify-content: center;
    align-items: center; }
`, "",{"version":3,"sources":["webpack://./src/modules/booths/components/screens/ActiveBoothScreen/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAW;EACX,YAAY,EAAA;EAFhB;IAIQ,aAAa;IACb,uBAAuB;IACvB,mBACJ,EAAA","sourcesContent":[".placeholder {\n    width: 54vw;\n    height: 18vh;\n    & > div:last-child {\n        display: flex;\n        justify-content: center;\n        align-items: center\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"placeholder": `styles_placeholder__f1ZSI`
};
export default ___CSS_LOADER_EXPORT___;
